




















































































































import { Component, Prop, Vue } from "vue-property-decorator";
import { mapState } from "vuex";
import { BPopover } from "bootstrap-vue";
import { ProviderFilter } from "@/store/modules/types";
import debounce from "debounce";

@Component({
  components: {
    BPopover,
  },
  computed: mapState("gaps", ["campaigns", "measureTypes"]),
})
export default class ProvidrFilter extends Vue {
  id = "provider-filter-popover";
  target = "provider-filter-target";
  filter = this.defaultFilter();
  defaultFilter(): ProviderFilter {
    return {
      name: "",
      campaignId: "",
      measureTypeId: "",
      list: Array<any>(),
    };
  }
  debounceName = debounce(() => {
    if (this.filter.name.length === 0 || this.filter.name.length >= 3) {
      this.getProviders();
    }
  }, 300);
  async getProviders() {
    try {
      const { name, campaignId, measureTypeId } = this.filter;
      const data = await this.$store.dispatch("gaps/getProviders", {
        name,
        campaignId,
        measureTypeId,
      });
      this.filter.list = data.map((provider) => {
        provider.checked = false;
        return provider;
      });
    } catch (error) {
      console.log(error);
    }
  }
  async checkProviders() {
    this.filter.list.forEach((provider) => {
      provider.checked = true;
    });
  }
  async uncheckProviders() {
    this.filter.list.forEach((provider) => {
      provider.checked = false;
    });
  }
  get checkedProviders(): Array<any> {
    return this.filter.list.filter((provider) => {
      return provider.checked;
    });
  }
  search() {
    const filter = { ...this.filter };
    this.$store.commit("gaps/SET_PROVIDER_FILTER", filter);
    this.close();
  }
  clear() {
    this.filter = this.defaultFilter();
    this.search();
  }
  close() {
    this.$root.$emit("bv::hide::popover", this.id);
    this.$emit("closed");
  }
  mounted() {
    const { cache } = this.$store.state.gaps.filter.provider;
    this.filter = JSON.parse(JSON.stringify(cache));
    if (!this.filter.list.length) {
      this.getProviders();
    }
  }
}
